import React, { useRef, useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { fadeGroup } from "./fade";

// Stylized 1:1 Statue of Liberty (oxidized copper PBR) on Liberty Island, SW harbor.
export default function StatueOfLiberty() {
  const torch = useRef();
  const copper = useMemo(
    () =>
      new THREE.MeshStandardMaterial({
        color: "#4fa392",
        metalness: 0.25,
        roughness: 0.62,
        envMapIntensity: 0.8,
      }),
    []
  );

  useFrame((state) => {
    if (torch.current)
      torch.current.material.emissiveIntensity = 0.6 + Math.sin(state.clock.elapsedTime * 3) * 0.15;
  });

  return (
    <group position={[-780, 0, 760]} rotation={[0, Math.PI * 0.15, 0]}>
      {/* island */}
      <mesh position={[0, 1, 0]} receiveShadow>
        <cylinderGeometry args={[70, 78, 4, 24]} />
        <meshStandardMaterial color="#5f6b4a" roughness={0.95} />
      </mesh>
      {/* star fort pedestal base */}
      <mesh position={[0, 14, 0]} castShadow>
        <cylinderGeometry args={[26, 30, 22, 11]} />
        <meshStandardMaterial color="#b9a98d" roughness={0.9} />
      </mesh>
      <mesh position={[0, 40, 0]} castShadow>
        <boxGeometry args={[26, 34, 26]} />
        <meshStandardMaterial color="#cdbfa4" roughness={0.85} />
      </mesh>
      {/* statue */}
      <group position={[0, 57, 0]} scale={[1.05, 1.05, 1.05]}>
        {/* robe body */}
        <mesh position={[0, 22, 0]} castShadow material={copper}>
          <coneGeometry args={[13, 46, 16]} />
        </mesh>
        {/* torso/chest */}
        <mesh position={[0, 44, 1]} castShadow material={copper}>
          <cylinderGeometry args={[6, 9, 14, 14]} />
        </mesh>
        {/* head */}
        <mesh position={[0, 56, 1]} castShadow material={copper}>
          <sphereGeometry args={[4.2, 18, 18]} />
        </mesh>
        {/* crown spikes */}
        {Array.from({ length: 7 }).map((_, i) => {
          const a = (i / 6 - 0.5) * Math.PI * 1.1;
          return (
            <mesh key={i} position={[Math.sin(a) * 5, 60, 1 + Math.cos(a) * 3]} rotation={[0, -a, 0]} material={copper}>
              <coneGeometry args={[0.7, 6, 5]} />
            </mesh>
          );
        })}
        {/* raised torch arm */}
        <mesh position={[7, 52, 1]} rotation={[0, 0, -0.5]} castShadow material={copper}>
          <cylinderGeometry args={[2, 2.6, 30, 10]} />
        </mesh>
        <mesh ref={torch} position={[15, 66, 1]}>
          <sphereGeometry args={[3, 16, 16]} />
          <meshStandardMaterial color="#ffd97a" emissive="#ffb300" emissiveIntensity={0.7} metalness={0.6} roughness={0.3} />
        </mesh>
        {/* tablet */}
        <mesh position={[-8, 40, 4]} rotation={[0.3, 0, 0.3]} castShadow material={copper}>
          <boxGeometry args={[8, 11, 1.4]} />
        </mesh>
      </group>
    </group>
  );
}
